// removed by extract-text-webpack-plugin
module.exports = {"list":"d3b8dfb1","button":"_4b57a1fc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/PrimaryCareProviderForm/index.styl
// module id = 5251
// module chunks = 39